var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}]},[_vm._v(_vm._s(_vm.ago)+" ("+_vm._s(_vm.formatted)+") ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }